import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AddEquipement from '../components/AddEquipement';
import api, { BASE_URL } from '../api/api';

// SVG Icons for each field category
const ChassisIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
);

const LicensePlateIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h10l4 12H3l4-12z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 9h6v2H9V9z" />
    </svg>
);

const CarIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-1.5-6H17a1 1 0 00-1-1H8a1 1 0 00-1 1h-.5L5 14m14 0v4a1 1 0 01-1 1h-1a1 1 0 01-1-1v-1H9v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-4m14 0H5" />
        <circle cx="8" cy="18" r="2" />
        <circle cx="16" cy="18" r="2" />
    </svg>
);

const EngineIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
    </svg>
);

const FuelIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
    </svg>
);

const GearIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
);

const SeatIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
);

const DoorIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
    </svg>
);

const SpeedometerIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
    </svg>
);

const CalendarIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
);

const ColorIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM7 21h2a2 2 0 002-2v-4a2 2 0 00-2-2H7m0-5h6l6 2v6l-6 2H7V9z" />
    </svg>
);

const HealthIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
    </svg>
);

const PriceIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
    </svg>
);

const ShieldIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
    </svg>
);

const WrenchIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
);

const PhotoIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
);

const DocumentIcon = () => (
    <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
);

const CloseIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
);

const CheckIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
    </svg>
);

const TrashIcon = () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
    </svg>
);

export default function AddVoiture({ onCreated, onUpdated, editingVoiture, onCancel }) {
    const { t, i18n } = useTranslation();
    const isRtl = i18n.language === 'ar';

    const [formData, setFormData] = useState({
        numero_chassis: '', matricule: '', marque: '', modele: '', version: '', annee: '', couleur: '',
        genre: '', carrosserie: '', poids: '', charge_utile: '', precedent_immatriculation: '',
        carburant: '', boite_vitesse: '', nb_places: '', nb_portes: '', kilometrage: '', puissance: '',
        etat_mecanique: '', etat_carrosserie: '', etat_suspension: '', etat_pneus: '', commentaire_etat: '',
        prix_location_jour: '', prix_location_semaine: '', prix_location_mois: '', disponible: true, motif_indisponibilite: '',
        assurance_compagnie: '', numero_police_assurance: '', date_expiration_assurance: '', date_mise_en_circulation: '',
        date_derniere_visite_tech: '', date_prochaine_visite_tech: '', date_derniere_vidange: '', kilometrage_derniere_vidange: '',
        kilometrage_prochaine_vidange: '', date_remplacement_distribution: '', kilometrage_remplacement_distribution: '',
        kilometrage_prochain_distribution: ''
    });

    const [equipements, setEquipements] = useState([]);
    const [selectedEquipements, setSelectedEquipements] = useState([]);
    const [photoVehicule, setPhotoVehicule] = useState(null);
    const [photoCarteGrise, setPhotoCarteGrise] = useState(null);
    const [photoAssurance, setPhotoAssurance] = useState(null);
    const [photosSupplementaires, setPhotosSupplementaires] = useState([]);
    const [existingPhotos, setExistingPhotos] = useState({
        vehicule: null,
        carteGrise: null,
        assurance: null,
        supplementaires: []
    });
    const [photosToDelete, setPhotosToDelete] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });

    // Required fields based on database schema
    const requiredFields = [
        'numero_chassis', 'matricule', 'marque', 'modele', 'annee', 'prix_location_jour',
        'assurance_compagnie', 'numero_police_assurance', 'date_expiration_assurance', 'date_mise_en_circulation'
    ];

    // Format date for input field (YYYY-MM-DD)
    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return '';
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        } catch (error) {
            console.error('Error formatting date:', error);
            return '';
        }
    };

    useEffect(() => {
        api.get('/equipements')
            .then(res => setEquipements(res.data))
            .catch(err => console.error('Erreur chargement équipements:', err));

        if (editingVoiture) {
            const updatedFormData = { ...formData };
            Object.keys(updatedFormData).forEach(key => {
                if (editingVoiture.hasOwnProperty(key)) {
                    if (key === 'disponible') {
                        updatedFormData[key] = Boolean(editingVoiture[key]);
                    } else if (key.includes('date') && editingVoiture[key]) {
                        updatedFormData[key] = formatDateForInput(editingVoiture[key]);
                    } else {
                        updatedFormData[key] = editingVoiture[key] || '';
                    }
                }
            });
            setFormData(updatedFormData);

            // Set existing photos
            setExistingPhotos({
                vehicule: editingVoiture.photo_vehicule,
                carteGrise: editingVoiture.photo_carte_grise,
                assurance: editingVoiture.photo_assurance,
                supplementaires: []
            });

            // Load supplementary photos
            if (editingVoiture.id) {
                api.get(`/voitures-equipements/voiture/${editingVoiture.id}`)
                    .then(res => {
                        const equipementIds = res.data.map(eq => eq.id);
                        setSelectedEquipements(equipementIds);
                    })
                    .catch(err => console.error('Erreur chargement équipements voiture:', err));

                // Load supplementary photos
                api.get(`/voitures-photos/voiture/${editingVoiture.id}`)
                    .then(res => {
                        setExistingPhotos(prev => ({
                            ...prev,
                            supplementaires: res.data
                        }));
                    })
                    .catch(err => console.error('Erreur chargement photos supplémentaires:', err));
            }
        }
    }, [editingVoiture]);

    const handleChange = e => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleFileChange = (e, setter) => {
        if (e.target.files[0]) {
            setter(e.target.files[0]);
        }
    };

    const handleMultiFileChange = e => {
        setPhotosSupplementaires(Array.from(e.target.files));
    };

    const handleEquipementToggle = id => {
        setSelectedEquipements(prev =>
            prev.includes(id) ? prev.filter(e => e !== id) : [...prev, id]
        );
    };

    const handleDeletePhoto = async (photoId) => {
        try {
            if (photoId) {
                // Mark supplementary photo for deletion
                setPhotosToDelete(prev => [...prev, photoId]);

                // Remove from existing photos
                setExistingPhotos(prev => ({
                    ...prev,
                    supplementaires: prev.supplementaires.filter(p => p.id !== photoId)
                }));
            }
        } catch (error) {
            console.error('Error deleting photo:', error);
            setMessage({ text: t('delete_photo_error'), type: 'error' });
        }
    };
    const handleSubmit = async e => {
        e.preventDefault();
        setIsSubmitting(true);
        setMessage({ text: '', type: '' });

        try {
            const fdVoiture = new FormData();

            Object.entries(formData).forEach(([key, val]) => {
                if (val !== null && val !== undefined) {
                    if (typeof val === 'boolean') {
                        fdVoiture.append(key, val ? 1 : 0);
                    } else {
                        const value = val === '' ? null : val;
                        if (value !== null) {
                            fdVoiture.append(key, value);
                        }
                    }
                }
            });

            if (photoVehicule) fdVoiture.append('photo_vehicule', photoVehicule);
            if (photoCarteGrise) fdVoiture.append('photo_carte_grise', photoCarteGrise);
            if (photoAssurance) fdVoiture.append('photo_assurance', photoAssurance);

            let response;
            if (editingVoiture) {
                response = await api.post(
                    `/voitures/${editingVoiture.id}?_method=PUT`,
                    fdVoiture,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );
            } else {
                response = await api.post(
                    '/voitures',
                    fdVoiture,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );
            }

            const voitureId = editingVoiture ? editingVoiture.id : response.data?.id || response.data[0]?.id;

            if (voitureId) {
                try {
                    // Delete marked photos
                    for (const photoId of photosToDelete) {
                        await api.delete(`/voitures-photos/${photoId}`);
                    }

                    // Update equipment
                    const payload = {
                        voiture_id: voitureId,
                        equipement_ids: selectedEquipements
                    };

                    if (editingVoiture) {
                        await api.put(`/voitures-equipements/${voitureId}`, payload);
                    } else {
                        await api.post('/voitures-equipements', payload);
                    }

                    // Upload new supplementary photos
                    if (photosSupplementaires.length > 0) {
                        const fdSupp = new FormData();
                        fdSupp.append('voiture_id', voitureId);
                        photosSupplementaires.forEach(file => fdSupp.append('photos', file));

                        await api.post(
                            '/voitures-photos/upload-multiple',
                            fdSupp,
                            { headers: { 'Content-Type': 'multipart/form-data' } }
                        );
                    }
                } catch (equipError) {
                    console.error('Erreur lors de l\'enregistrement des équipements ou photos:', equipError);
                }
            }

            const successMessage = editingVoiture
                ? t('update_success')
                : t('save_success');

            setMessage({ text: successMessage, type: 'success' });

            if (editingVoiture) {
                if (onUpdated) onUpdated(response.data);
            } else {
                if (onCreated) onCreated(response.data);
            }

            if (!editingVoiture) {
                setFormData({
                    numero_chassis: '', matricule: '', marque: '', modele: '', version: '', annee: '', couleur: '',
                    genre: '', carrosserie: '', poids: '', charge_utile: '', precedent_immatriculation: '',
                    carburant: '', boite_vitesse: '', nb_places: '', nb_portes: '', kilometrage: '', puissance: '',
                    etat_mecanique: '', etat_carrosserie: '', etat_suspension: '', etat_pneus: '', commentaire_etat: '',
                    prix_location_jour: '', prix_location_semaine: '', prix_location_mois: '', disponible: true, motif_indisponibilite: '',
                    assurance_compagnie: '', numero_police_assurance: '', date_expiration_assurance: '', date_mise_en_circulation: '',
                    date_derniere_visite_tech: '', date_prochaine_visite_tech: '', date_derniere_vidange: '', kilometrage_derniere_vidange: '',
                    kilometrage_prochaine_vidange: '', date_remplacement_distribution: '', kilometrage_remplacement_distribution: '',
                    kilometrage_prochain_distribution: ''
                });
                setSelectedEquipements([]);
                setPhotoVehicule(null);
                setPhotoCarteGrise(null);
                setPhotoAssurance(null);
                setPhotosSupplementaires([]);
                setExistingPhotos({
                    vehicule: null,
                    carteGrise: null,
                    assurance: null,
                    supplementaires: []
                });
                setPhotosToDelete([]);
            }

        } catch (err) {
            console.error('Error in handleSubmit:', err);
            let errorMessage = t('save_error');
            if (err.response) {
                errorMessage = err.response.data?.error ||
                    err.response.data?.message ||
                    `Erreur ${err.response.status}: ${err.response.statusText}`;
            } else if (err.request) {

            } else {
                errorMessage = err.message || errorMessage;
            }
            setMessage({ text: errorMessage, type: 'error' });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleEquipementAjoute = (equipement) => {
        setEquipements(prev => [...prev, equipement]);
        setSelectedEquipements(prev => [...prev, equipement.id]);
    };

    const getFieldIcon = (field) => {
        switch (field) {
            case 'numero_chassis': return <ChassisIcon />;
            case 'matricule': return <LicensePlateIcon />;
            case 'marque':
            case 'modele':
            case 'version': return <CarIcon />;
            case 'annee': return <CalendarIcon />;
            case 'couleur': return <ColorIcon />;
            case 'carburant': return <FuelIcon />;
            case 'boite_vitesse': return <GearIcon />;
            case 'nb_places': return <SeatIcon />;
            case 'nb_portes': return <DoorIcon />;
            case 'kilometrage':
            case 'kilometrage_derniere_vidange':
            case 'kilometrage_prochaine_vidange':
            case 'kilometrage_remplacement_distribution':
            case 'kilometrage_prochain_distribution': return <SpeedometerIcon />;
            case 'puissance': return <EngineIcon />;
            case 'etat_mecanique':
            case 'etat_carrosserie':
            case 'etat_suspension':
            case 'etat_pneus':
            case 'commentaire_etat': return <HealthIcon />;
            case 'prix_location_jour':
            case 'prix_location_semaine':
            case 'prix_location_mois': return <PriceIcon />;
            case 'assurance_compagnie':
            case 'numero_police_assurance': return <ShieldIcon />;
            case 'date_expiration_assurance':
            case 'date_mise_en_circulation':
            case 'date_derniere_visite_tech':
            case 'date_prochaine_visite_tech':
            case 'date_derniere_vidange':
            case 'date_remplacement_distribution': return <CalendarIcon />;
            default: return <WrenchIcon />;
        }
    };

    const fieldLabels = {
        'numero_chassis': t('chassis_number'),
        'matricule': t('license_plate'),
        'marque': t('brand'),
        'modele': t('model'),
        'version': t('version_label'),
        'annee': t('year'),
        'couleur': t('color'),
        'genre': t('genre'),
        'carrosserie': t('body_type'),
        'poids': t('weight'),
        'charge_utile': t('payload'),
        'precedent_immatriculation': t('prev_registration'),
        'carburant': t('fuel'),
        'boite_vitesse': t('transmission'),
        'nb_places': t('seats_count'),
        'nb_portes': t('doors_count'),
        'kilometrage': t('mileage'),
        'puissance': t('power'),
        'etat_mecanique': t('mech_state'),
        'etat_carrosserie': t('body_state'),
        'etat_suspension': t('suspension_state'),
        'etat_pneus': t('tires_state'),
        'commentaire_etat': t('state_comment'),
        'prix_location_jour': t('daily_price'),
        'prix_location_semaine': t('weekly_price'),
        'prix_location_mois': t('monthly_price'),
        'disponible': t('avail_status'),
        'motif_indisponibilite': t('unavail_reason'),
        'assurance_compagnie': t('insurance_company'),
        'numero_police_assurance': t('policy_number'),
        'date_expiration_assurance': t('expiration_date'),
        'date_mise_en_circulation': t('registration_date'),
        'date_derniere_visite_tech': t('last_tech_visit'),
        'date_prochaine_visite_tech': t('next_tech_visit'),
        'date_derniere_vidange': t('last_oil_change'),
        'kilometrage_derniere_vidange': t('oil_change_mileage'),
        'kilometrage_prochaine_vidange': t('next_oil_change_mileage'),
        'date_remplacement_distribution': t('distrib_replacement_date'),
        'kilometrage_remplacement_distribution': t('distrib_replacement_mileage'),
        'kilometrage_prochain_distribution': t('next_distrib_mileage')
    };

    const groupedFields = {
        [t('general_info')]: [
            'numero_chassis', 'matricule', 'marque', 'modele', 'version', 'annee', 'couleur',
            'genre', 'carrosserie', 'poids', 'charge_utile', 'precedent_immatriculation'
        ],
        [t('tech_specs')]: [
            'carburant', 'boite_vitesse', 'nb_places', 'nb_portes', 'kilometrage', 'puissance'
        ],
        [t('vehicle_condition')]: [
            'etat_mecanique', 'etat_carrosserie', 'etat_suspension', 'etat_pneus', 'commentaire_etat'
        ],
        [t('pricing')]: [
            'prix_location_jour', 'prix_location_semaine', 'prix_location_mois', 'disponible', 'motif_indisponibilite'
        ],
        [t('insurance_info')]: [
            'assurance_compagnie', 'numero_police_assurance', 'date_expiration_assurance'
        ],
        [t('history_info')]: [
            'date_mise_en_circulation', 'date_derniere_visite_tech', 'date_prochaine_visite_tech'
        ],
        [t('maintenance_info')]: [
            'date_derniere_vidange', 'kilometrage_derniere_vidange', 'kilometrage_prochaine_vidange',
            'date_remplacement_distribution', 'kilometrage_remplacement_distribution', 'kilometrage_prochain_distribution'
        ]
    };

    const renderPhotoPreview = (photo, type, label) => {
        const existingPhoto =
            type === 'vehicule' ? existingPhotos.vehicule :
                type === 'carteGrise' ? existingPhotos.carteGrise :
                    existingPhotos.assurance;

        const hasPhoto = photo || existingPhoto;

        const photoUrl = photo ? URL.createObjectURL(photo) :
            existingPhoto ? `${BASE_URL}/uploads/${existingPhoto}` : null;

        return (
            <div className="space-y-3">
                <label className={`block text-sm font-medium text-gray-700 flex items-center ${isRtl ? 'flex-row-reverse' : ''}`}>
                    {type === 'vehicule' ? <PhotoIcon /> :
                        type === 'carteGrise' ? <DocumentIcon /> : <ShieldIcon />}
                    <span className={isRtl ? 'mr-2' : 'ml-2'}>{label}</span>
                </label>

                {hasPhoto ? (
                    <div className="relative">
                        <img
                            src={photoUrl}
                            alt={label}
                            className="w-full h-40 object-cover rounded-lg border-2 border-gray-200"
                        />
                        {/* No delete button for main photos */}
                    </div>
                ) : (
                    <label className="flex flex-col items-center justify-center w-full h-40 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-white hover:bg-gray-50 hover:border-blue-400 transition-all group">
                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            {type === 'vehicule' ? <PhotoIcon className="w-8 h-8 mb-2 text-gray-400 group-hover:text-blue-500 transition-colors" /> :
                                type === 'carteGrise' ? <DocumentIcon className="w-8 h-8 mb-2 text-gray-400 group-hover:text-blue-500 transition-colors" /> :
                                    <ShieldIcon className="w-8 h-8 mb-2 text-gray-400 group-hover:text-blue-500 transition-colors" />}
                            <p className="mb-2 text-sm text-gray-500 text-center">
                                <span className="font-semibold">{t('click_to_upload')}</span>
                            </p>
                            <p className="text-xs text-gray-400">{t('allowed_formats')}</p>
                        </div>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={e => handleFileChange(e,
                                type === 'vehicule' ? setPhotoVehicule :
                                    type === 'carteGrise' ? setPhotoCarteGrise :
                                        setPhotoAssurance
                            )}
                            className="hidden"
                        />
                    </label>
                )}

                {photo && (
                    <p className={`text-xs text-green-600 bg-green-50 p-2 rounded truncate ${isRtl ? 'text-right' : 'text-left'}`}>
                        ✓ {photo.name}
                    </p>
                )}
            </div>
        );
    };
    return (
        <div className={`bg-white rounded-2xl shadow-xl w-full max-w-6xl ${isRtl ? 'rtl text-right' : 'ltr text-left'}`} dir={isRtl ? 'rtl' : 'ltr'}>
            {/* Modal Header */}
            <div className={`border-b border-gray-200 px-6 py-4 flex justify-between items-center bg-gradient-to-r from-blue-50 to-indigo-50 ${isRtl ? 'flex-row-reverse' : ''}`}>
                <h2 className={`text-xl font-bold text-gray-800 flex items-center ${isRtl ? 'flex-row-reverse' : ''}`}>
                    <CarIcon className={isRtl ? 'ml-3' : 'mr-3'} />
                    {editingVoiture ? t('edit_vehicle') : t('new_vehicle')}
                </h2>
                <button
                    onClick={onCancel}
                    className="text-gray-400 hover:text-gray-500 p-2 rounded-full hover:bg-gray-100 transition-colors"
                >
                    <CloseIcon />
                </button>
            </div>

            {/* Form Content */}
            <div className="p-6 max-h-[80vh] overflow-y-auto">
                <form onSubmit={handleSubmit} className="space-y-8">
                    {message.text && (
                        <div
                            className={`p-4 rounded-lg ${message.type === 'success'
                                    ? 'bg-green-50 text-green-800 border border-green-200'
                                    : 'bg-red-50 text-red-800 border border-red-200'
                                }`}
                        >
                            <div className={`flex items-center ${isRtl ? 'flex-row-reverse' : ''}`}>
                                {message.type === 'success' ? <CheckIcon className={`w-5 h-5 text-green-500 ${isRtl ? 'ml-2' : 'mr-2'}`} /> : null}
                                {message.text}
                            </div>
                        </div>
                    )}

                    {/* Grouped Fields */}
                    {Object.entries(groupedFields).map(([groupName, fields]) => (
                        <div key={groupName} className="bg-gray-50 rounded-lg p-6 space-y-5">
                            <h3 className={`text-lg font-semibold text-gray-800 border-b border-gray-300 pb-3 flex items-center ${isRtl ? 'flex-row-reverse' : ''}`}>
                                {getFieldIcon(fields[0])}
                                <span className={isRtl ? 'mr-2' : 'ml-2'}>{groupName}</span>
                            </h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                {fields.map(field => (
                                    <div key={field} className="space-y-2">
                                        <label className={`block text-sm font-medium text-gray-700 flex items-center ${isRtl ? 'flex-row-reverse text-right' : 'text-left'}`}>
                                            {getFieldIcon(field)}
                                            <span className={`inline-block ${isRtl ? 'mr-2' : 'ml-2'}`}>
                                                {fieldLabels[field] || field.replace(/_/g, ' ')}
                                                {requiredFields.includes(field) && !editingVoiture && (
                                                    <span className="text-red-500 ml-1">*</span>
                                                )}
                                            </span>
                                        </label>
                                        {field === 'disponible' ? (
                                            <label className={`inline-flex items-center mt-1 bg-white rounded-lg p-3 border border-gray-200 hover:border-blue-300 transition-colors cursor-pointer ${isRtl ? 'flex-row-reverse' : ''}`}>
                                                <input
                                                    type="checkbox"
                                                    name={field}
                                                    checked={formData[field]}
                                                    onChange={handleChange}
                                                    className="rounded border-gray-300 text-blue-600 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                                                />
                                                <span className={`${isRtl ? 'mr-3' : 'ml-3'} text-sm text-gray-700 font-medium`}>{t('available')}</span>
                                            </label>
                                        ) : field.includes('date') ? (
                                            <div className="relative">
                                                <input
                                                    type="date"
                                                    name={field}
                                                    value={formData[field] || ''}
                                                    onChange={handleChange}
                                                    className={`block w-full ${isRtl ? 'pr-10 pl-4 text-right' : 'pl-10 pr-4 text-left'} py-3 border border-gray-200 rounded-lg shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:ring-opacity-50 sm:text-sm bg-white transition-all`}
                                                    required={requiredFields.includes(field) && !editingVoiture}
                                                />
                                                <div className={`absolute inset-y-0 ${isRtl ? 'right-0 pr-3' : 'left-0 pl-3'} flex items-center pointer-events-none`}>
                                                    {getFieldIcon(field)}
                                                </div>
                                            </div>
                                        ) : field === 'commentaire_etat' ? (
                                            <div className="relative">
                                                <textarea
                                                    name={field}
                                                    value={formData[field] || ''}
                                                    onChange={handleChange}
                                                    rows={3}
                                                    className={`block w-full ${isRtl ? 'pr-10 pl-4 text-right' : 'pl-10 pr-4 text-left'} py-3 border border-gray-200 rounded-lg shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:ring-opacity-50 sm:text-sm bg-white resize-none transition-all`}
                                                    placeholder={t('comment_placeholder')}
                                                />
                                                <div className={`absolute top-3 ${isRtl ? 'right-0 pr-3' : 'left-0 pl-3'} flex items-start pointer-events-none`}>
                                                    {getFieldIcon(field)}
                                                </div>
                                            </div>
                                        ) : field === 'motif_indisponibilite' ? (
                                            <div className="relative">
                                                <textarea
                                                    name={field}
                                                    value={formData[field] || ''}
                                                    onChange={handleChange}
                                                    rows={2}
                                                    className={`block w-full ${isRtl ? 'pr-10 pl-4 text-right' : 'pl-10 pr-4 text-left'} py-3 border border-gray-200 rounded-lg shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:ring-opacity-50 sm:text-sm bg-white resize-none transition-all`}
                                                    placeholder={t('unavail_placeholder')}
                                                />
                                                <div className={`absolute top-3 ${isRtl ? 'right-0 pr-3' : 'left-0 pl-3'} flex items-start pointer-events-none`}>
                                                    {getFieldIcon(field)}
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="relative">
                                                <input
                                                    type={
                                                        [
                                                            'prix_location_jour',
                                                            'prix_location_semaine',
                                                            'prix_location_mois',
                                                            'kilometrage',
                                                            'puissance',
                                                            'nb_places',
                                                            'nb_portes',
                                                            'annee',
                                                            'kilometrage_derniere_vidange',
                                                            'kilometrage_prochaine_vidange',
                                                            'kilometrage_remplacement_distribution',
                                                            'kilometrage_prochain_distribution',
                                                        ].includes(field)
                                                            ? 'number'
                                                            : 'text'
                                                    }
                                                    name={field}
                                                    value={formData[field] || ''}
                                                    onChange={handleChange}
                                                    className={`block w-full ${isRtl ? 'pr-10 pl-4 text-right' : 'pl-10 pr-4 text-left'} py-3 border border-gray-200 rounded-lg shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200 focus:ring-opacity-50 sm:text-sm bg-white transition-all`}
                                                    required={requiredFields.includes(field) && !editingVoiture}
                                                    step={field.includes('prix') ? '0.01' : undefined}
                                                    min={field.includes('prix') || field.includes('kilometrage') || field === 'annee' || field === 'puissance' || field === 'nb_places' || field === 'nb_portes' ? '0' : undefined}
                                                />
                                                <div className={`absolute inset-y-0 ${isRtl ? 'right-0 pr-3' : 'left-0 pl-3'} flex items-center pointer-events-none`}>
                                                    {getFieldIcon(field)}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}

                    {/* Equipment Section */}
                    <div className="bg-gray-50 rounded-lg p-6 space-y-5">
                        <h3 className={`text-lg font-semibold text-gray-800 border-b border-gray-300 pb-3 flex items-center ${isRtl ? 'flex-row-reverse' : ''}`}>
                            <WrenchIcon />
                            <span className={isRtl ? 'mr-2' : 'ml-2'}>{t('equipment')}</span>
                        </h3>
                        <div className="space-y-4">
                            <AddEquipement onAdd={handleEquipementAjoute} />
                            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                                {equipements.map(eq => (
                                    <label key={eq.id} className={`inline-flex items-center bg-white rounded-lg p-3 border border-gray-200 hover:border-blue-300 transition-colors cursor-pointer ${isRtl ? 'flex-row-reverse' : ''}`}>
                                        <input
                                            type="checkbox"
                                            checked={selectedEquipements.includes(eq.id)}
                                            onChange={() => handleEquipementToggle(eq.id)}
                                            className="rounded border-gray-300 text-blue-600 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                                        />
                                        <span className={`${isRtl ? 'mr-3' : 'ml-3'} text-sm text-gray-700 font-medium`}>{eq.nom}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Photos Section */}
                    <div className="bg-gray-50 rounded-lg p-6 space-y-5">
                        <h3 className={`text-lg font-semibold text-gray-800 border-b border-gray-300 pb-3 flex items-center ${isRtl ? 'flex-row-reverse' : ''}`}>
                            <PhotoIcon />
                            <span className={isRtl ? 'mr-2' : 'ml-2'}>{t('photos_docs')}</span>
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            {/* Photo véhicule */}
                            {renderPhotoPreview(photoVehicule, 'vehicule', t('vehicle_photo'))}

                            {/* Carte grise */}
                            {renderPhotoPreview(photoCarteGrise, 'carteGrise', t('registration_card'))}

                            {/* Assurance */}
                            {renderPhotoPreview(photoAssurance, 'assurance', t('insurance_doc'))}
                        </div>

                        {/* Photos supplémentaires */}
                        <div className="space-y-3">
                            <label className={`block text-sm font-medium text-gray-700 flex items-center ${isRtl ? 'flex-row-reverse' : ''}`}>
                                <PhotoIcon />
                                <span className={isRtl ? 'mr-2' : 'ml-2'}>{t('extra_photos')}</span>
                            </label>

                            {/* Existing supplementary photos */}
                            {existingPhotos.supplementaires.length > 0 && (
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                                    {existingPhotos.supplementaires.map(photo => (
                                        <div key={photo.id} className="relative group/photo">
                                            <img
                                                src={`${BASE_URL}/uploads/${photo.photo_url}`}
                                                alt="Photo supplémentaire"
                                                className="w-full h-32 object-cover rounded-lg border-2 border-gray-200"
                                            />
                                            <button
                                                type="button"
                                                onClick={() => handleDeletePhoto(photo.id)}
                                                className="absolute top-2 right-2 bg-red-500 text-white p-1.5 rounded-full hover:bg-red-600 opacity-0 group-hover/photo:opacity-100 transition-opacity shadow-lg"
                                            >
                                                <TrashIcon />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* Upload new supplementary photos */}
                            <label
                                className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-white hover:bg-gray-50 hover:border-blue-400 transition-all group">
                                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                                    <PhotoIcon
                                        className="w-6 h-6 mb-2 text-gray-400 group-hover:text-blue-500 transition-colors" />
                                    <p className="mb-2 text-sm text-gray-500 text-center">
                                        <span className="font-semibold">{t('click_to_upload')}</span> {t('drag_drop')}
                                    </p>
                                    <p className="text-xs text-gray-400">{t('allowed_formats')}</p>
                                </div>
                                <input
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={handleMultiFileChange}
                                    className="hidden"
                                />
                            </label>
                            {photosSupplementaires.length > 0 && (
                                <p className={`text-xs text-green-600 bg-green-50 p-2 rounded ${isRtl ? 'text-right' : 'text-left'}`}>
                                    ✓ {photosSupplementaires.length} {t('files_selected')}
                                </p>
                            )}
                        </div>
                    </div>

                    {/* Form Actions */}
                    <div className={`flex justify-between items-center pt-6 border-t border-gray-200 ${isRtl ? 'flex-row-reverse' : ''}`}>
                        <p className="text-sm text-gray-500 flex items-center">
                            <span className="text-red-500 mr-1">*</span>
                            {t('required_fields_notice')}
                        </p>
                        <div className={`flex ${isRtl ? 'space-x-reverse space-x-3' : 'space-x-3'}`}>
                            <button
                                type="button"
                                onClick={onCancel}
                                className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors font-medium"
                                disabled={isSubmitting}
                            >
                                {t('cancel')}
                            </button>
                            <button
                                type="submit"
                                className="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all flex items-center font-medium shadow-lg"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <>
                                        <svg
                                            className={`animate-spin h-4 w-4 text-white ${isRtl ? 'ml-2' : 'mr-2'}`}
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                        >
                                            <circle
                                                className="opacity-25"
                                                cx="12"
                                                cy="12"
                                                r="10"
                                                stroke="currentColor"
                                                strokeWidth="4"
                                            ></circle>
                                            <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                            ></path>
                                        </svg>
                                        {editingVoiture ? t('save_changes', 'Enregistrement...') : t('creating', 'Création...')}
                                    </>
                                ) : (
                                    editingVoiture ? t('save_changes', 'Modifier') : t('add_vehicle', 'Ajouter')
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
